import UpdateAlert from "./UpdateAlert";

export default UpdateAlert;
